let sessionExpiredHandler = null;
let isHandlingExpiry = false;

export const registerSessionExpiredHandler = (handler) => {
    sessionExpiredHandler = handler;
    return () => {
        sessionExpiredHandler = null;
    };
};

const getErrorText = (response) => {
    const data = response?.data;
    if (!data) return '';

    const error = data.error || {};
    return [
        error.message,
        error.name,
        error.code,
        data.message,
    ]
        .filter(Boolean)
        .join(' ')
        .toLowerCase();
};

export const isMsalTokenExpiredError = (response) => {
    if (!response || response.status !== 401) return false;

    const text = getErrorText(response);
    return text.includes('expir') && (
        text.includes('token')
        || text.includes('msal')
        || text.includes('session')
        || text.includes('jwt')
    );
};

export const handleMsalTokenExpired = () => {
    if (isHandlingExpiry || !sessionExpiredHandler) return;

    isHandlingExpiry = true;
    sessionExpiredHandler();

    setTimeout(() => {
        isHandlingExpiry = false;
    }, 1000);
};
